


function SideNavBarInvestorKYC({ currentStep, completedSteps }) {
  const steps = [
    "Personal Details",
    "Other details",
    "ID Verification",
    "Selfie Capture",
    "Review & Submit"
  ];

  return (

    <div className="sidebar">

      < div className="sidebar-contentttt" >
        <div className="investor-header">
         

          <h1 className="investor-title">
            Investor Verification
          </h1>

          <p className="investor-subtitle" style={{ color: "white" }}>
            Complete your KYC in under <br /> 5 minutes to start investing with confidence.
          </p>




          <div className="progress-steps">
            {steps.map((label, index) => {
              const stepNumber = index + 1;
              const isCompleted = completedSteps.includes(stepNumber);
              const isActive = currentStep === stepNumber;

              return (
                <div
                  key={stepNumber}
                  className={`progress-step 
          ${isActive ? "active" : ""} 
          ${isCompleted ? "completed" : "upcoming"}`}
                >
                  <div className="step-circle">
                    {isCompleted ? "✓" : stepNumber}
                  </div>

                  <div className="step-label">
                    {label}
                  </div>
                </div>
              );
            })}
          </div>



        </div>
      </div>
    </div>


  );
};

export default SideNavBarInvestorKYC;
